import axios from '../../plugins/axios';
import indexedDB from '../../plugins/indexedDB';
import { CACHE_TIME } from '../../js/utils/vars';

export const namespaced = true;

export const state = () => ({
    promocode_read: true,
    homeLoaded: false,
    newVersion: false,
    settings: {
        home: {
            template: '1-2-2',
            services_list: [],
            lastUpdate: 0
        },
        desktop_menu: {
            menu: [],
            lastUpdate: 0
        },
        payment: {
            lastUpdate: 0
        },
        order_repeat: {
            lastUpdate: 0
        },
        agreement: {
            lastUpdate: 0
        },
        personal_information: {
            lastUpdate: 0
        },
        faq: {
            lastUpdate: 0
        },
        referal_program: {},
        referer_promocode: [],
        stories: [],
        stories_settings: {}
    },
});

export const mutations = {
    CLEAR(state) {
        state.settings = {};
    },
    SET_SETTINGS(state, payload) {
        state.settings[payload.page] = {
            ...state.settings[payload.page],
            ...payload.settings
        };
    },
    SET_FAQ(state, payload) {
        state.settings.faq = payload;
    },
    SET_STORIES(state, payload) {
        state.settings.stories = payload;
    },
    SET_REFERAL_PROGRAM(state, payload) {
        state.settings.referal_program = payload;
    },
    SET_REFERER_PROMOCODE(state, payload) {
        state.settings.referer_promocode = payload;
    },
    SET_CHECK_PROMOCODE_READ(state, payload) {
        state.promocode_read = payload;
    },
    SET_STORIES_SETTINGS(state, payload) {
        state.settings.stories_settings = payload;
    },
    SET_NEW_VERSION(state, payload) {
        state.newVersion = payload;
    }
};

export const actions = {
    setSettings({ commit }, data) {
        commit('SET_SETTINGS', data);
    },
    async fetch({ commit, state }, { page }) {
        try {
            if ((new Date()).getTime() - state.settings[page].lastUpdate > CACHE_TIME) {
                const { data } = await axios.get(`/front/page-settings/${ page }`);
                if(data) {
                    commit('SET_SETTINGS', data);
                    state.settings[page].lastUpdate = (new Date()).getTime();
                }
            }
        } catch (e) {}
        state.homeLoaded = true;
    },
    async getFAQ({ commit }) {
        const { data } = await axios.get('/front/settings/faq');
        commit('SET_FAQ', data);
    },
    async getReferalProgramSettings({ commit }) {
        const { data } = await axios.get('front/settings/referal-program');
        commit('SET_REFERAL_PROGRAM', data);
    },
    async getRefererPromocode({ commit }) {
        const { data } = await axios.get('front/settings/referer-promocode');
        commit('SET_REFERER_PROMOCODE', data);
    },
    async checkPromocodeRead ({ commit }) {
        const { data } = await axios.get('front/settings/promocode-read');
        commit('SET_CHECK_PROMOCODE_READ', data );
    },
    async promocodeReading({ commit }) {
        await axios.post('front/settings/promocode-reading');
    },
    async getStories({ commit }) {
        const { data } = await axios.get('front/settings/stories');
        state.request = null;

        const result = [];
        const placesGroups = {};
        const localData = await indexedDB.get('mircity-storiesIndexes') || {};

        for (const story of data.sort((a, b) => (a.position > b.position) ? -1 : 1)) {
            if (+story.position !== 0) {
                if (placesGroups[+story.position]) {
                    placesGroups[+story.position].push(story);
                } else {
                    placesGroups[+story.position] = [ story ];
                }
            }
        }

        const nextLocalData = {};

        for (const groupKey in placesGroups) {
            const group = placesGroups[groupKey];
            const lastShownId = localData[groupKey] || null;
            const lastShowStoryIndex = lastShownId ? group.findIndex(b => b.id === lastShownId) : -1;
            let currentBanner;
            currentBanner = group[+lastShowStoryIndex + 1] || group[0];
            result.push(currentBanner);
            nextLocalData[groupKey] = currentBanner.id;
        }
        await indexedDB.set('mircity-storiesIndexes', nextLocalData);
        commit('SET_STORIES', result );
    },
    async getStoriesSettings({ commit }) {
        const { data } = await axios.get('front/settings/stories-settings');
        commit('SET_STORIES_SETTINGS', data ? data : {} );
    }
};